const SECOND_IN_MS = 1000
const MINUTE_IN_MS = 60 * SECOND_IN_MS
const HOUR_IN_MS   = 60 * MINUTE_IN_MS
const DAY_IN_MS    = 24 * HOUR_IN_MS
const WEEK_IN_MS   =  7 * DAY_IN_MS
const MONTH_IN_MS  = 30 * DAY_IN_MS
const DAYS_OF_WEEK = 7

const UNIX_EPOCH = new Date('1 January 1970 00:00:00 UTC')
const UTC_OFFSET = UNIX_EPOCH.getTimezoneOffset()

module.exports.consts = {
  SECOND_IN_MS,
  MINUTE_IN_MS,
  HOUR_IN_MS,
  DAY_IN_MS,
  WEEK_IN_MS,
  MONTH_IN_MS,
  DAYS_OF_WEEK,
  UNIX_EPOCH,
  UTC_OFFSET
}
